import React, { useCallback, useEffect, useMemo } from 'react'


import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import './ViewMultiReimbursements.scss';
import { Button } from '@aws-amplify/ui-react';
import { Flex, Table } from 'antd';

import { Tabs } from 'antd';
export default function ViewMultiReimbursements(props) {
 
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  
  const columns = [
    {
      title: 'Claimed Amount',
      dataIndex: 'claimedAmount',
    },
    
    {
      title: 'Status',
      dataIndex: 'status',
    },
   
    {
      title: 'Action',
      dataIndex: '',
      render: (text, record) => {
        return (
          record.status == 'pending' && props.my === "" ? <Button onClick={() => props.onApprove(record.reimbursement_id)}>Approve</Button>
            : (<div></div>)
        )
      }
    },
  ];



  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;



  const pendingTable = () => {
    return (<Flex gap="middle" vertical>
      <Flex align="center" gap="middle">

        {hasSelected ? `Selected ${selectedRowKeys.length} items` : null}
      </Flex>
      <Table rowSelection={rowSelection} columns={columns} dataSource={props.reimbursements} />
    </Flex>)
  }


  return (
    <div>
      <Card className="reimbursements-card">
        <CardContent>
          <div className="headerText">{props.my?"Expense/claim/reimbursement - mine":"Expense/claim/reimbursement - others"}</div>
          {pendingTable}


        </CardContent>
      </Card>
    </div>
  )
}

